const map = {
	"./0/Kambi/SecondaryMenu.layout.js": [
		8017,
		[
			50274,
			73879
		]
	],
	"./0/Poker/SecondaryMenu.layout.js": [
		4131,
		[
			50274,
			71006
		]
	],
	"./0/Spectate/SecondaryMenu.layout.js": [
		33790,
		[
			50274,
			46246
		]
	],
	"./1/Kambi/SecondaryMenu.layout.js": [
		21623,
		[
			11450
		]
	],
	"./1/Poker/SecondaryMenu.layout.js": [
		83330,
		[
			50274,
			47147
		]
	],
	"./1/Spectate/SecondaryMenu.layout.js": [
		97680,
		[
			50274,
			2003
		]
	],
	"./101/Spectate/SecondaryMenu.layout.js": [
		31883,
		[
			50274,
			61542
		]
	],
	"./31/Kambi/SecondaryMenu.layout.js": [
		38185,
		[
			50274,
			44391
		]
	],
	"./31/Poker/SecondaryMenu.layout.js": [
		38342,
		[
			50274,
			40796
		]
	],
	"./31/Spectate/SecondaryMenu.layout.js": [
		78059,
		[
			50274,
			58068
		]
	],
	"./58/Spectate/SecondaryMenu.layout.js": [
		39885,
		[
			50274,
			22719
		]
	],
	"./75/Kambi/SecondaryMenu.layout.js": [
		66881,
		[
			50274,
			46719
		]
	],
	"./75/Spectate/SecondaryMenu.layout.js": [
		97550,
		[
			50274,
			74724
		]
	],
	"./76/Kambi/SecondaryMenu.layout.js": [
		81061,
		[
			50274,
			79108
		]
	],
	"./76/Spectate/SecondaryMenu.layout.js": [
		5089,
		[
			50274,
			63327
		]
	],
	"./8/Poker/SecondaryMenu.layout.js": [
		23323,
		[
			50274,
			88838
		]
	],
	"./8/Spectate/SecondaryMenu.layout.js": [
		65881,
		[
			50274,
			82669,
			13022
		]
	],
	"./81/Kambi/SecondaryMenu.layout.js": [
		68634,
		[
			50274,
			72522
		]
	],
	"./81/Spectate/SecondaryMenu.layout.js": [
		85447,
		[
			50274,
			51845
		]
	],
	"./84/Kambi/SecondaryMenu.layout.js": [
		45614,
		[
			50274,
			34635
		]
	],
	"./84/Spectate/SecondaryMenu.layout.js": [
		16140,
		[
			50274,
			17484
		]
	],
	"./86/Spectate/SecondaryMenu.layout.js": [
		41529,
		[
			50274,
			25290
		]
	],
	"./87/Spectate/SecondaryMenu.layout.js": [
		88894,
		[
			50274,
			58919
		]
	],
	"./88/Spectate/SecondaryMenu.layout.js": [
		93507,
		[
			50274,
			81288
		]
	],
	"./89/Spectate/SecondaryMenu.layout.js": [
		84560,
		[
			50274,
			25290,
			37709
		]
	],
	"./90/Spectate/SecondaryMenu.layout.js": [
		27186,
		[
			50274,
			25290,
			65883
		]
	],
	"./91/Spectate/SecondaryMenu.layout.js": [
		71917,
		[
			50274,
			25290,
			49774
		]
	],
	"./92/Spectate/SecondaryMenu.layout.js": [
		29860,
		[
			50274,
			87253
		]
	],
	"./94/Spectate/SecondaryMenu.layout.js": [
		58521,
		[
			50274,
			68439
		]
	],
	"./95/Spectate/SecondaryMenu.layout.js": [
		71636,
		[
			50274,
			55738
		]
	],
	"./96/Poker/SecondaryMenu.layout.js": [
		91694,
		[
			50274,
			53545
		]
	],
	"./96/Spectate/SecondaryMenu.layout.js": [
		45780,
		[
			50274,
			82669,
			92593
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 21871;
module.exports = webpackAsyncContext;